module.exports = __webpack_public_path__ + "assets/apple-icon-180x180.a4bef3e9.png";